"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var styled_components_1 = __importDefault(require("styled-components"));
var styled_system_1 = require("styled-system");
var Text_1 = require("./Text");
var Hyperlink_1 = require("./Hyperlink");
exports.ButtonLink = styled_components_1["default"].button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border: none;\n  font-size: 100%;\n  padding: 0;\n\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  background-color: ", ";\n  border: none;\n  font-size: 100%;\n  padding: 0;\n\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.transparent;
}, Text_1.bold, Text_1.align, Hyperlink_1.hyperlink, styled_system_1.space);
exports.ButtonLink.displayName = 'ButtonLink';
exports.ButtonLink.defaultProps = {
    bold: true
};
exports["default"] = exports.ButtonLink;
var templateObject_1;
//# sourceMappingURL=ButtonLink.js.map